import { Component, Input, ViewChild, ElementRef, OnChanges, SimpleChanges, AfterViewInit, OnDestroy } from '@angular/core';
import { Chart, ChartConfiguration, registerables } from 'chart.js';

Chart.register(...registerables);

@Component({
    selector: 'app-chart-widget',
    templateUrl: './chart-widget.component.html',
    styleUrls: ['./chart-widget.component.scss'],
    standalone: false
})
export class ChartWidgetComponent implements OnChanges, AfterViewInit, OnDestroy {
    @Input() title: string = '';
    @Input() chartType: 'line' | 'bar' | 'pie' | 'doughnut' = 'line';
    @Input() chartData: any = null;
    @Input() chartOptions: any = {};

    @ViewChild('chartCanvas', { static: false }) chartCanvas?: ElementRef<HTMLCanvasElement>;

    chart: Chart | null = null;
    isLoading: boolean = false;

    constructor() { }

    ngAfterViewInit() {
        console.log('DATA:', this.chartData);
        // Wait for next tick to ensure canvas element is fully rendered
        if (this.chartData && this.chartCanvas) {
            setTimeout(() => {
                this.createChart();
            }, 2000);
        }


    }

    ngAfterViewChecked() {
        if (this.chartData && this.chartCanvas && !this.chart) {
            this.createChart();
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if ((changes['chartData'] || changes['chartOptions']) && this.chartData) {
            if (this.chart) {
                this.updateChart();
            }
        }
    }

    createChart() {
        if (!this.chartCanvas?.nativeElement) {
            return;
        }

        if (this.chart) {
            this.chart.destroy();
        }

        this.chart = new Chart(this.chartCanvas.nativeElement, {
            type: this.chartType,
            data: this.chartData,
            options: {
                responsive: true,
                maintainAspectRatio: false, // 🔥 FIX
                plugins: {
                    legend: {
                        display: true,
                        position: 'bottom'
                    }
                },
                ...this.chartOptions
            }
        });
    }

    updateChart() {
        if (this.chart && this.chartData) {
            this.chart.data = this.chartData;
            this.chart.options = {
                ...this.chart.options,
                ...this.chartOptions
            };
            this.chart.update();
        }
    }

    destroyChart() {
        if (this.chart) {
            this.chart.destroy();
            this.chart = null;
        }
    }

    ngOnDestroy() {
        this.destroyChart();
    }
}
